import { Footer } from "@/parts/footer";
import { Layout } from "@/parts/layout";
import { Meta } from "@/parts/meta";
import { getClient } from "@/utils/client";
import type { GetStaticPropsContext } from "next";
import { dodaysQuery, settingsQuery } from "@/utils/queries";
import { IDoDay, IHome, ISettings } from "@/utils/types";

export default function Home({
  page,
  dodays,
  settings,
}: {
  page: IHome;
  dodays: IDoDay[];
  settings: ISettings;
}) {
  return (
    <div className="bg-grey">
      <Meta settings={settings} data={page.meta} />
      {/* {dodays.map((doday, i) => {
        return (
          <div key={i}>
            <Link href={`/doedag/${doday.slug.current}`}>{doday.name}</Link>
          </div>
        )
      })} */}
      <Layout data={page.layout} />
      <Footer data={settings} />
    </div>
  );
}

export async function getStaticProps(ctx: GetStaticPropsContext) {
  const draftMode = ctx.draftMode ?? false;
  const client = getClient(draftMode);
  const page = await client.fetch(`*[_type == "home"][0]{
    ...,
    layout {
      ...,
      parts[]{
        ...,
        gallery{
          ...,
          items[]{
            ...,
            "playbackId": video.asset->playbackId
          }
        },
        "members": select(
          memberSource == "allTeamMembers" => *[_type == "teamMember"]{..., "videoPlaybackId": video.asset->playbackId},
          memberSource == "allMembers" => *[_type == "member"]{..., "videoPlaybackId": video.asset->playbackId},
          memberSource == "allTestimonials" => *[_type == "testimonial"]{..., "title": name, "quote": coalesce(headline, quote), "description": quote, "role": coalesce(role, company), "partnerLogo": partner->logo, "partnerLogoLight": partner->lightLogo, "videoPlaybackId": video.asset->playbackId},
          members[]->{..., "title": coalesce(title, name), "quote": coalesce(headline, quote), "description": coalesce(description, quote), "role": coalesce(role, company), "partnerLogo": partner->logo, "partnerLogoLight": partner->lightLogo, "videoPlaybackId": video.asset->playbackId}
        ),
        "partners": select(allPartners == true => *[_type == "partner"], partners[]->),
        _type == 'testimonials' => {
          ...,
          "testimonials": testimonials[]->{
            name,
            role,
            company,
            quote,
            image,
            button
          }
        },
        _type == 'stats' => {
          ...,
          "items": select(
            allStats == true => *[_type == "stat"] | order(order asc) {
              ...,
              media[]{
                ...,
                "playbackId": video.asset->playbackId
              }
            },
            items[]->{
              ...,
              media[]{
                ...,
                "playbackId": video.asset->playbackId
              }
            }
          ),
          "partners": *[_type == "partner"],
        },
        _type == 'knowledge' => {
          ...,
          highlights[]{
            ...,
            "fileURL": file.asset->url
          },
          items[]{
            ...,
            
          items[]{
            ...,
            "fileURL": file.asset->url
          }
          }
        },
        _type == 'faqs' => {
          ...,
          "collectionQuestions": *[_type == "faqItem" && count(audience[@ in ^.^.audience]) > 0]{
            question,
            answer
          },
          "pickedQuestions": items[]->{question, answer}
        },
        _type == 'blogPosts' => {
          ...,
          "blogs": *[_type == "blogPost" && ^.tag in tags] | order(date desc)
        }
          
      }
    }
  }`);
  const settings = await client.fetch(settingsQuery);

  const dodays = await client.fetch(dodaysQuery);

  return {
    props: {
      page,
      settings,
      dodays,
      draftMode,
    },
    revalidate: 5,
  };
}
